<template>
  <n-space vertical>
    <n-form ref="formRef" :model="formSnapshot" :style="{ maxWidth: '100%' }">
      <n-form-item label="Date" path="date">
        <n-date-picker 
          v-model:value="formSnapshot.date" 
          type="date"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </n-form-item>
      
      <n-divider>Account Balances</n-divider>
      
      <n-list bordered>
        <n-list-item v-for="account in accounts" :key="account.id">
          <n-grid :x-gap="12" :cols="24">
            <n-grid-item span="8">
              <n-text strong>{{ account.name }}</n-text>
            </n-grid-item>
            <n-grid-item span="8">
              <n-input-number 
                v-model:value="formSnapshot.balances[account.id]" 
                :min="0"
                :precision="2"
                :placeholder="getLastBalance(account)"
                style="width: 100%"
              />
            </n-grid-item>
            <n-grid-item span="8">
              <n-input 
                v-model:value="formSnapshot.comments[account.id]" 
                type="text"
                placeholder="Optional comment"
              />
            </n-grid-item>
          </n-grid>
        </n-list-item>
      </n-list>

      <div style="margin-top: 24px; text-align: right">
        <n-button type="primary" @click="submitSnapshot" :loading="loading">
          Create Snapshot
        </n-button>
      </div>
    </n-form>
  </n-space>
</template>

<script>
  import { useAccountStore } from '../stores/accountStore.js';
  import { useSnapshotStore } from '../stores/snapshotStore.js';
  import { onMounted, computed, ref } from 'vue';
  
  export default {
    setup() {
      const accountStore = useAccountStore();
      const snapshotStore = useSnapshotStore();
      const accounts = computed(() => accountStore.accounts);
      const loading = ref(false);
  
      const formSnapshot = ref({
        date: null,
        balances: {},
        comments: {}
    });
  
      onMounted(async () => {
        await accountStore.fetchAccounts();
        initializeBalances();
      });
  
      const initializeBalances = () => {
        formSnapshot.value.balances = accounts.value.reduce((acc, account) => {
          // Initialize with last known balance if available
          acc[account.id] = account.last_snapshot ? account.last_snapshot.balance : 0;
          return acc;
        }, {});
        formSnapshot.value.comments = accounts.value.reduce((acc, account) => {
            acc[account.id] = '';
            return acc;
        }, {});
    };
  
      const getLastBalance = (account) => {
        return account.last_snapshot ? 
          `Last balance: ${account.last_snapshot.balance}` : 
          'No previous balance';
      };
  
      const submitSnapshot = async () => {
        if (!formSnapshot.value.date) {
          // Show error notification
          return;
        }
  
        loading.value = true;
        try {
          await snapshotStore.addBatchSnapshot(formSnapshot.value);
          // Refresh accounts to get updated last_snapshot
          await accountStore.fetchAccounts();
          // Reset form with new last balances
          formSnapshot.value.date = null;
          initializeBalances();
        } catch (error) {
          console.error('Error creating snapshot:', error);
        } finally {
          loading.value = false;
        }
      };
  
      return {
        accounts,
        formSnapshot,
        loading,
        getLastBalance,
        submitSnapshot
      };
    }
  };
  </script>
  
  <style scoped>
  .account-balance {
    margin-bottom: 1rem;
  }
  </style>